<template>
  <v-card>
    <div id="editbox" style="display: flex; flex-direction: column">
      <li v-for="item in this.headers" :key="item.id">
        <input v-model="item.default" :placeholder="item.name" />
      </li>
      <v-btn
        id="editButton"
        style="width: 100px"
        elevation="4"
        rounded
        @click="saveEdit(original, headers)"
      >
        <v-icon right>save</v-icon>
        <span>Save</span>
      </v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'GenericEditBox',
  props: {
    parentID: {
      type: Number,
      default: null
    },
    title: {
      type: String
    },
    headers: {
      type: Array,
      default: null
    },
    original: {
      type: Object
    }
  },
  data () {
    return {
      search: '',
      items: []
    }
  },
  async beforeMount () {},
  methods: {
    async saveEdit (original, newfield) {
      if (this.title === 'Location') {
        if (newfield[0].default === null || newfield[0].default === `` || !(newfield[0].default.length !== 6)) {
          newfield[0].default = 'ignore'
        }
        if (newfield[1].default === null || newfield[1].default === `` || !(newfield[1].default.length !== 6)) {
          newfield[1].default = 'ignore'
        }
        if (newfield[2].default === null || newfield[2].default === ``) {
          newfield[2].default = 'ignore'
        }
        if (newfield[3].default === null || newfield[3].default === ``) {
          newfield[3].default = 'ignore'
        }
        if (newfield[4].default === null || newfield[4].default === ``) {
          newfield[4].default = 'ignore'
        }
        if (newfield[5].default === null || newfield[5].default === ``) {
          newfield[5].default = 'ignore'
        }
        if (newfield[6].default === null || newfield[6].default === ``) {
          newfield[6].default = 'ignore'
        }
        if (newfield[7].default === null || newfield[7].default === ``) {
          newfield[7].default = 'ignore'
        }
        if (newfield[8].default === null || newfield[8].default === `` || !(newfield[8].default.length !== 8)) {
          newfield[8].default = 'ignore'
        }
        const response = await this.$http.post(
          `manifest/location/bulk?ids_to_update=[${original.id}]`,
          {
            locations: [
              {
                eastings: newfield[0].default,
                northings: newfield[1].default,
                loc_lat: newfield[2].default,
                loc_lon: newfield[3].default,
                addr1: newfield[4].default,
                addr2: newfield[5].default,
                addr3: newfield[6].default,
                addr4: newfield[7].default,
                addr5: newfield[8].default
              }
            ]
          }
        )
        window.alert(response.data.message)
      }
      if (this.title === 'Assets') {
        if (newfield[0].default === null || newfield[0].default === ``) {
          newfield[0].default = 'ignore'
        }
        const allowedStates = ['Free', 'Reserved', 'Blocking', 'Installed']
        if (newfield[1].default === null || newfield[1].default === `` || !(allowedStates.includes(newfield[2].default))) {
          newfield[1].default = 'ignore'
        }
        if (newfield[2].default === null || newfield[2].default === `` || !(newfield[3].default.includes('_'))) {
          newfield[2].default = 'ignore'
        }
        if (newfield[3].default === null || newfield[3].default === ``) {
          newfield[3].default = 'ignore'
        }
        if (newfield[4].default === null || newfield[4].default === ``) {
          newfield[4].default = 'ignore'
        }
        if (newfield[5].default === null || newfield[5].default === ``) {
          newfield[5].default = 'ignore'
        }
        const response = await this.$http.post(
          `manifest/assetinfo/bulk?ids_to_update=[${original.id}]`,
          {
            assetinfo_arr: [
              {
                co_assetid: 'ignore',
                co_description: newfield[0].default,
                assetstate: newfield[1].default,
                co_groupcode: newfield[2].default,
                devicename: newfield[4].default,
                co_locationid: newfield[3].default,
                assetnote: newfield[5].default
              }
            ],
            co_groupcode_arr: [newfield[3].default]
          }
        )
        window.alert(response.data.message)
      }
      if (this.title === 'Physical') {
        if (newfield[0].default === null || newfield[0].default === ``) {
          newfield[0].default = 'ignore'
        }
        if (newfield[1].default === null || newfield[1].default === ``) {
          newfield[1].default = 'ignore'
        }
        if (newfield[2].default === null || newfield[2].default === ``) {
          newfield[2].default = 'ignore'
        }
        if (newfield[3].default === null || newfield[3].default === ``) {
          newfield[3].default = 'ignore'
        }
        const response = await this.$http.post(
          `manifest/physicalinfo/bulk?ids_to_update=[${original.id}]`,
          {
            physicalInfoRecords: [
              {
                smartdeviceid: newfield[0].default,
                serialnum: newfield[1].default,
                physicaltype: newfield[2].default,
                devicename: newfield[3].default
              }
            ]
          }
        )
        window.alert(response.data.message)
      }
      if (this.title === 'Group') {
        if (newfield[0].default === null || newfield[0].default === ``) {
          newfield[0].default = 'ignore'
        }
        if (newfield[1].default === null || newfield[1].default === ``) {
          newfield[1].default = 'ignore'
        }
        //
        const response = await this.$http.post(`/manifest/groupinfo`, {
          groupinfolist: [
            {
              co_groupcode: 'ignore',
              co_groupname: newfield[0].default,
              co_groupdesc: newfield[1].default
            }
          ]
        })
        window.alert(response.data.message)
      }
    }
  }
}
</script>
